import constants from '@/util/constants.js'

/**
 * 供应商筛选项（instiIds），下拉数据与 helpStart 页「救援公司名称」同源
 */
export default {
  data () {
    return {
      /** @type {string|number} 供应商机构 id */
      instiIds: '',
      /** @type {Array<{ id: number|string, name: string }>} */
      assistInstituteOptions: []
    }
  },
  methods: {
    /**
     * 加载救援机构下拉列表（rescue/user/search_assist，默认中国 +86，与 helpStart 一致）
     * @returns {void}
     */
    loadAssistInstituteOptions () {
      const nation = encodeURIComponent('+86')
      fetch(constants.domain + 'rescue/user/search_assist', {
        method: 'POST',
        body: `token=${this.token}&nation=${nation}&kw=`,
        mode: 'cors',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
        .then(function (res) {
          return res.json()
        })
        .then((data) => {
          if (data && data.obj) {
            this.assistInstituteOptions = data.obj
          }
        })
        .catch((err) => {
          console.error('加载供应商列表失败:', err)
        })
    },
    /**
     * 是否已选择供应商筛选
     * @returns {boolean}
     */
    hasInstiIdsFilter () {
      return this.instiIds !== '' && this.instiIds != null && this.instiIds !== undefined
    },
    /**
     * 为 list_case 查询串追加 instiIds
     * @param {string} tl 已有查询参数串
     * @returns {string}
     */
    appendInstiIdsQuery (tl) {
      if (this.hasInstiIdsFilter()) {
        return tl + `&instiIds=${this.instiIds}`
      }
      return tl
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/cmd_center/star/mixins/instiIdsFilterMixin.js